import { render, staticRenderFns } from "./coursePeriodDetail.vue?vue&type=template&id=3b428847&scoped=true&"
import script from "./coursePeriodDetail.vue?vue&type=script&lang=js&"
export * from "./coursePeriodDetail.vue?vue&type=script&lang=js&"
import style0 from "./coursePeriodDetail.vue?vue&type=style&index=0&id=3b428847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b428847",
  null
  
)

export default component.exports